var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMjPointLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288.14 70.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #093fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.92.58h7.72l5.08,13.9c.63,1.85,1.17,3.85,1.8,5.78h.19c.63-1.93,1.16-3.93,1.78-5.78l4.92-13.9h7.72v31.29h-6.44v-11.48c0-3.05.57-7.6.9-10.63h-.19l-2.57,7.4-4.42,11.99h-3.93l-4.43-11.99-2.5-7.4h-.19c.33,3.03.9,7.58.9,10.63v11.48h-6.34V.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.57,26.78l4.81-3.58c1.16,2.15,2.76,3.13,4.36,3.13,2.53,0,3.9-1.29,3.9-5.47V.58h7.07v20.88c0,6.02-3.12,10.99-10.04,10.99-4.78,0-7.93-1.87-10.1-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.53.58h10.75c6.88,0,12.44,2.46,12.44,10.06s-5.61,10.61-12.24,10.61h-3.87v10.62h-7.07V.58ZM169.05,15.63c3.89,0,5.73-1.73,5.73-4.99s-2.09-4.45-5.92-4.45h-3.26v9.44h3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.66,16.08c0-10.22,5.77-16.08,14.21-16.08s14.21,5.9,14.21,16.08-5.77,16.36-14.21,16.36-14.21-6.13-14.21-16.36ZM206.83,16.08c0-6.27-2.69-9.98-6.96-9.98s-6.96,3.7-6.96,9.98,2.69,10.25,6.96,10.25,6.96-3.98,6.96-10.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.97.58h7.07v31.29h-7.07V.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.42.58h7.25l8.16,15.56,3.09,6.87h.19c-.33-3.31-.9-7.69-.9-11.38V.58h6.74v31.29h-7.25l-8.16-15.6-3.09-6.83h-.19c.33,3.45.9,7.64.9,11.33v11.1h-6.74V.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.46,6.51h-8.61V.58h24.3v5.93h-8.61v25.35h-7.07V6.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.69,48.85h-5.66v-2.93h14.81v2.93h-5.66v16.69h-3.48v-16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.11,45.92h11.81v2.93h-8.33v5.03h7.06v2.93h-7.06v5.81h8.63v2.93h-12.11v-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.22,55.8c0-6.42,4.02-10.24,8.99-10.24,2.46,0,4.42,1.18,5.65,2.48l-1.86,2.24c-1.01-1.01-2.18-1.7-3.72-1.7-3.19,0-5.48,2.7-5.48,7.1s2.11,7.19,5.4,7.19c1.74,0,3.08-.8,4.19-2.02l1.86,2.18c-1.59,1.85-3.64,2.86-6.18,2.86-4.93,0-8.84-3.61-8.84-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.53,45.92h3.48v7.88h7.93v-7.88h3.48v19.62h-3.48v-8.7h-7.93v8.7h-3.48v-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.42,45.92h3.58l6.1,11.03,2.03,4.19h.12c-.17-2.03-.44-4.51-.44-6.7v-8.52h3.31v19.62h-3.58l-6.1-11.05-2.03-4.17h-.12c.17,2.08.44,4.44.44,6.62v8.59h-3.31v-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.06,55.65c0-6.35,3.54-10.09,8.65-10.09s8.65,3.76,8.65,10.09-3.54,10.25-8.65,10.25-8.65-3.9-8.65-10.25ZM188.79,55.65c0-4.4-1.99-7.07-5.08-7.07s-5.08,2.66-5.08,7.07,1.99,7.22,5.08,7.22,5.08-2.82,5.08-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.32,45.92h3.48v16.69h8.15v2.93h-11.63v-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.34,55.65c0-6.35,3.54-10.09,8.65-10.09s8.65,3.76,8.65,10.09-3.54,10.25-8.65,10.25-8.65-3.9-8.65-10.25ZM224.07,55.65c0-4.4-1.99-7.07-5.08-7.07s-5.08,2.66-5.08,7.07,1.99,7.22,5.08,7.22,5.08-2.82,5.08-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.56,55.8c0-6.42,4.07-10.24,9.29-10.24,2.78,0,4.69,1.22,5.93,2.48l-1.86,2.24c-.98-.96-2.14-1.7-3.96-1.7-3.48,0-5.82,2.7-5.82,7.1s2.08,7.19,6.01,7.19c1.09,0,2.17-.31,2.8-.86v-4.24h-3.7v-2.86h6.82v8.65c-1.31,1.32-3.58,2.33-6.26,2.33-5.29,0-9.24-3.61-9.24-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.44,45.92h3.48v19.62h-3.48v-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.9,45.92h11.81v2.93h-8.33v5.03h7.06v2.93h-7.06v5.81h8.63v2.93h-12.11v-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.69,63.03l2.03-2.39c1.4,1.34,3.29,2.24,5.11,2.24,2.21,0,3.42-1,3.42-2.53,0-1.61-1.27-2.13-3.05-2.89l-2.68-1.16c-1.93-.8-3.97-2.33-3.97-5.2,0-3.13,2.76-5.53,6.59-5.53,2.29,0,4.51.95,6.05,2.5l-1.79,2.21c-1.25-1.06-2.58-1.69-4.26-1.69-1.86,0-3.07.87-3.07,2.3,0,1.54,1.49,2.11,3.12,2.78l2.65,1.11c2.33.97,3.97,2.45,3.97,5.29,0,3.18-2.64,5.83-7.04,5.83-2.65,0-5.21-1.04-7.07-2.87Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.12,
    y: 0.79,
    width: 23.06,
    height: 23.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.06,
    y: 23.85,
    width: 23.06,
    height: 23.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 46.91,
    width: 23.06,
    height: 23.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.11,39.64v22.23h-12.92v8.77h15.15c3.62,0,6.55-2.93,6.55-6.55v-24.45h-8.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjPointLogoBlack);
export default __webpack_public_path__ + "static/media/mj_point_logo_black.529cd260be762226c05cb5a41eac2b82.svg";
export { ForwardRef as ReactComponent };